import React, { useEffect, useState } from "react";
import axios from "axios";
import "./NewsEvents.css";

const API_BASE = "https://spst.in/myapp/api/uploads";

function NewsEvents() {
  const [uploads, setUploads] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axios.get(`${API_BASE}/get_notice.php`);

      const data = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];

      setUploads(data);
      setCurrentIndex(0);
    } catch (err) {
      console.error("Error fetching latest updates:", err);
      setError("Unable to load latest updates.");
      setUploads([]);
    } finally {
      setLoading(false);
    }
  };

  // Previous
  const handlePrevious = () => {
    if (uploads.length <= 1) return;

    setCurrentIndex((prev) =>
      prev === 0 ? uploads.length - 1 : prev - 1
    );
  };

  // Next
  const handleNext = () => {
    if (uploads.length <= 1) return;

    setCurrentIndex((prev) =>
      prev === uploads.length - 1 ? 0 : prev + 1
    );
  };

  // Open attached PDF/file
  const openNotice = (row) => {
    if (!row?.file_path) return;

    let filePath = String(row.file_path).trim();

    // Full URL already returned by API
    if (
      filePath.startsWith("http://") ||
      filePath.startsWith("https://")
    ) {
      window.open(filePath, "_blank", "noopener,noreferrer");
      return;
    }

    // Remove starting slash
    filePath = filePath.replace(/^\/+/, "");

    let fileUrl;

    // Example:
    // myapp/api/uploads/file.pdf
    if (filePath.startsWith("myapp/")) {
      fileUrl = `https://spst.in/${filePath}`;
    }

    // Example:
    // api/uploads/file.pdf
    else if (filePath.startsWith("api/")) {
      fileUrl = `https://spst.in/myapp/${filePath}`;
    }

    // Example:
    // uploads/file.pdf
    else if (filePath.startsWith("uploads/")) {
      fileUrl = `https://spst.in/myapp/${filePath}`;
    }

    // Example:
    // file.pdf
    else {
      fileUrl = `${API_BASE}/${filePath}`;
    }

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const currentNotice = uploads[currentIndex];

  return (
    <section className="latest-updates-section">

      {/* Heading */}
      <div className="latest-updates-heading">
        <div className="latest-updates-heading-left">
          <span className="latest-updates-heading-icon">
            <i className="fa fa-bullhorn" aria-hidden="true"></i>
          </span>

          <div>
            <h2>Latest Updates</h2>
            <span>Important announcements and notifications</span>
          </div>
        </div>

        {/* Counter */}
        {!loading && uploads.length > 0 && (
          <div className="latest-updates-count">
            {currentIndex + 1} / {uploads.length}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="latest-updates-box">

        {loading ? (
          <div className="latest-updates-message">
            <i
              className="fa fa-spinner fa-spin"
              aria-hidden="true"
            ></i>

            <span>Loading latest updates...</span>
          </div>
        ) : error ? (
          <div className="latest-updates-message error">
            {error}
          </div>
        ) : uploads.length === 0 ? (
          <div className="latest-updates-message">
            No latest updates available.
          </div>
        ) : (
          <>
            {/* Previous */}
            <button
              type="button"
              className="update-nav-btn update-prev"
              onClick={handlePrevious}
              disabled={uploads.length <= 1}
              aria-label="Previous update"
            >
              <i
                className="fa fa-chevron-left"
                aria-hidden="true"
              ></i>
            </button>

            {/* Current Update */}
            <div
              className={`latest-update-content ${
                currentNotice?.file_path ? "clickable" : ""
              }`}
              onClick={() => openNotice(currentNotice)}
              role={currentNotice?.file_path ? "button" : undefined}
              tabIndex={currentNotice?.file_path ? 0 : undefined}
              onKeyDown={(e) => {
                if (
                  currentNotice?.file_path &&
                  (e.key === "Enter" || e.key === " ")
                ) {
                  e.preventDefault();
                  openNotice(currentNotice);
                }
              }}
            >
              <div className="latest-update-icon">
                <i
                  className="fa fa-angle-double-right"
                  aria-hidden="true"
                ></i>
              </div>

              <div className="latest-update-text">
                <span className="latest-update-label">
                  Announcement
                </span>

                <h3>
                  {currentNotice?.name || "Latest Update"}
                </h3>

                {currentNotice?.file_path && (
                  <div className="latest-update-open">
                    Click here to view

                    <i
                      className="fa fa-external-link"
                      aria-hidden="true"
                    ></i>
                  </div>
                )}
              </div>
            </div>

            {/* Next */}
            <button
              type="button"
              className="update-nav-btn update-next"
              onClick={handleNext}
              disabled={uploads.length <= 1}
              aria-label="Next update"
            >
              <i
                className="fa fa-chevron-right"
                aria-hidden="true"
              ></i>
            </button>
          </>
        )}
      </div>

      {/* Bottom Navigation */}
      {!loading && uploads.length > 1 && (
        <div className="latest-updates-bottom">

          <button
            type="button"
            className="update-text-btn"
            onClick={handlePrevious}
          >
            <i
              className="fa fa-angle-left"
              aria-hidden="true"
            ></i>

            Previous
          </button>

          {/* Dots */}
          <div className="update-dots">
            {uploads.map((row, index) => (
              <button
                key={row.id || index}
                type="button"
                className={`update-dot ${
                  index === currentIndex ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`View update ${index + 1}`}
              />
            ))}
          </div>

          <button
            type="button"
            className="update-text-btn"
            onClick={handleNext}
          >
            Next

            <i
              className="fa fa-angle-right"
              aria-hidden="true"
            ></i>
          </button>

        </div>
      )}

    </section>
  );
}

export default NewsEvents;